// extracted by mini-css-extract-plugin
export default {"card":"InTaxSummaryCard_card__+SwfU","kpi":"InTaxSummaryCard_kpi__GQN01"};